import * as React from "react";
import { Modal, Button, Header, ModalHeader, ModalContent } from "@/components/bp/bp-ui";
import Plot from "react-plotly.js";
import { Layout, Config } from "plotly.js";
import { BPButton } from "@/components/bp/bpbutton";
import { ModalActions, ModalDescription } from "@/components/bp/bp-ui";

interface MyPlotlyProps {
    data: any;
    layout: Partial<Layout>;
    config: Partial<Config>;
    title: string;
    width?: number;
    autoWidth?: boolean;
}

interface MyPlotlyState {
    open: boolean;
}

export class MyPlotly extends React.Component<MyPlotlyProps, MyPlotlyState> {
    unmounted: boolean = false;

    setOpen(value: boolean) {
        if (!this.unmounted)
            this.setState({ ...this.state, open: value })
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            open: false,
        };
    }

    componentWillUnmount(){
        this.unmounted = true;
    }

    render() {
        return (
            <>
                <Modal
                    size={"fullscreen"}
                    onClose={() => this.setOpen(false)}
                    onOpen={() => this.setOpen(true)}
                    open={this.state.open}>
                    <ModalHeader>{this.props.title}</ModalHeader>
                    <ModalContent scrolling>
                        <ModalDescription style={{ textAlign: "center" }}>
                            <Plot style={{}} data={this.props.data} layout={{ ...this.props.layout, autosize: true }} useResizeHandler={true} config={{ ...this.props.config, responsive: true }} />
                        </ModalDescription>
                    </ModalContent>
                    <ModalActions>
                        <BPButton primary onClick={() => this.setOpen(false)}>
                            {window.translation.common.close}
                        </BPButton>
                    </ModalActions>
                </Modal>
                <Plot style={{}} data={this.props.data} layout={{ ...this.props.layout, autosize: this.props.autoWidth, width: this.props.width }} config={{
                    ...this.props.config, displaylogo: false, modeBarButtonsToAdd: [
                        {
                            title: '',
                            name: 'Open in Dialog',
                            icon: {
                                width: 16,
                                height: 16,
                                path: 'M 16,8 13,5 V 7 H 9 V 3 h 2 L 8,0 5,3 H 7 V 7 H 3 V 4.999 L 0,8 2.977,11 V 9 H 7 v 4 H 5 l 3,3 3,-3 H 9 V 9 h 4 v 2.001 z',
                                transform: 'matrix(0.84852814,0.84852814,-0.84852814,0.84852814,8.0016263,-5.5764502)',
                            },
                            click: () => {
                                this.setOpen(true);
                            }
                        }
                    ],
                }} />
            </>
        );
    }
}
